import React from 'react';
export function HowItWorks() {
  const steps = ['Descargue la guía en su teléfono, tableta o imprímala en papel.', 'Siga el Calendario de 30 Días realizando un ejercicio sencillo cada mañana.', 'Aplique el Método ANCLA en sus conversaciones diarias y note la diferencia en su retención.'];
  return <section className="bg-amber-50 py-16 md:py-24 px-4" data-id="element-118">
      <div className="max-w-4xl mx-auto" data-id="element-119">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-900 mb-12 text-center" data-id="element-120">
          ¿Cómo funciona?
        </h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-121">
          {steps.map((step, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-md text-center relative mt-6 md:mt-0" data-id="element-122">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-amber-600 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg" data-id="element-123">
                {index + 1}
              </div>
              <p className="text-lg text-stone-700 mt-4 leading-relaxed" data-id="element-124">
                {step}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}